import { ApiServiceV2, CMSStoryblokServiceV2 } from '@sunrise-upc/ajax-lib';
import {
  getCookies,
  getLocalStorageWithExpiry,
  getSessionStorage,
  removeLocalStorage,
  setLocalStoreWithExpiry
} from '../utils/utils';
import { API_BASE_BASEPOINT, APIResourceConstants } from './api-constants';
import Cookies from 'js-cookie';
import { v4 as generateUID } from 'uuid';
import {
  DEVICE_INSURANCE,
  FIXNET,
  HARDWARE,
  MOBILE,
  ONE_ECOMMERCE_OTT,
  P2PSUBSCRIBEDPLAN,
  PRE_TO_POST,
  QOQA,
  TV_SERVICE_OPTION,
  VOUCHERCODE,
  VOUCHERTYPE
} from '../utils/constants';
import { getAccessDataFromLineCheck } from '../components/lineTable/LineTableV3.utils';
import { LineTableBasicPropConfig } from './LineTableBasicPropConfig';
import { errorTrackingDataLayer } from '../utils/AnalyticsUtils';
import { apiResConstants } from '../components/LineCheckV3/APIResourceConstants';
import { getDeviceNotes } from '../components/UltimateBundleLinetable/DpTableUtils';
import {fetchOttItems} from '../components/StaticLineTable/Product.utils'

// Device cart utility functions moved here to avoid circular dependency
const getDeviceCartNotes = (deviceDetails: any, upFrontValue: string) => {
  let note = '';
  const smartUpgradeInstallments =
    deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments;
  const installments = deviceDetails?.selectedVarientDetails?.hardwarePrices?.installments;
  const basePrice = deviceDetails?.selectedVarientDetails?.hardwarePrices?.basePrice;

  if (smartUpgradeInstallments) {
    note = `${smartUpgradeInstallments?.duration} months, CHF ${upFrontValue} upfront, CHF ${smartUpgradeInstallments?.monthlyPayment?.value}/month`;
  } else if (installments) {
    note = `${installments?.duration} months, CHF ${installments?.monthlyPayment?.value}/month`;
  } else if (basePrice) {
    note = `CHF ${basePrice?.value} one-time payment`;
  }
  return note;
};

const getDeviceCartItem = (deviceDetails: any) => {
  let items = [];
  const contractDuration =
    deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments?.duration ?? 0;
  const upFrontValue =
    deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments?.upFrontPayment
      ?.value ?? 0;
  const insuranceValue =
    deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments?.insurance
      ?.value ?? 0;
  const deviceItem = {
    itemType: HARDWARE,
    id: deviceDetails?.selectedVarientDetails?.id ?? '',
    contractTerm: contractDuration,
    note: getDeviceNotes(deviceDetails, upFrontValue)
  };
  deviceItem && items?.push(deviceItem);

  if (insuranceValue) {
    const flexItem = {
      itemType: DEVICE_INSURANCE,
      id: deviceDetails?.insuranceName
    };
    items?.push(flexItem);
  }
  return items?.length > 0 ? items : null;
};

let AuthData: any = typeof window !== undefined && Cookies.get('sunriseAuth');
AuthData = AuthData && JSON.parse(AuthData);

export const fetchCountryList = async (name: string, lang: string, url: string, TTL: number) => {
  const getCountryData = getLocalStorageWithExpiry(`${name}_${lang}_countryData`);
  if (getCountryData) {
    return getCountryData;
  } else {
    try {
      const sbParams = {
        language: lang,
        type: 'B2C'
      };
      const res = await CMSStoryblokServiceV2.get(url, sbParams);
      const stories = res.data?.stories;
      if (stories && stories.length > 0)
        setLocalStoreWithExpiry(`${name}_${lang}_countryData`, stories, TTL);
      return stories;
    } catch (e: any) {
      // eslint-disable-next-line no-console
      console.error(e);
      return e;
    }
  }
};

export const fetchOfferingDataV2 = async (
  requestBody: any,
  url: any,
  returnPromo?: boolean
): Promise<any> => {
  try {
    localStorage.removeItem('entertainment');
    const options = {
      headers: {
        'x-correlation-id': generateUID(),
        'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
      },
      params: {}
    };
    if (returnPromo) {
      options.params = {
        returnPromo: true
      };
    }
    const URL = url + APIResourceConstants.LINE_TABLEV2;
    const productDynamicData: any = await ApiServiceV2.getApiServiceInstance()
      .post(URL, requestBody, options)
      .then((res): any => {
        if (res.status == 200) {
          return res?.data;
        }
      });
    if (productDynamicData.error) {
      return productDynamicData.error;
    } else {
      const response: any[] = [];
      productDynamicData?.forEach((data: any) => {
        response[data.id] = data;
      });
      return response;
    }
  } catch (error: any) {
    if (error?.response?.data?.code || error?.response?.status === 504) {
      errorTrackingDataLayer(error?.response);
    }
    // eslint-disable-next-line no-console
    console.log('error--->', error);
  }
};

export const createCartV2 = async (
  productData: any,
  radioValue: string,
  defaultPromo: string,
  cartUrl: string,
  productType: string,
  chooseGift?: any,
  enabledP2P?: any,
  P2PData?: any,
  isQoqaFlow?: boolean,
  qVoucher: any = '',
  deviceDetails?: any,
  tvOptions?: any,
  discountRef?: string,
  discountVersion?: string
): Promise<any> => {
  let cartData: any = {};
  /**WIN FLows*/
  
  // Get OTT data from session storage
  const ottCartData = getSessionStorage(ONE_ECOMMERCE_OTT);
  
  if (productType === FIXNET) {
    let mobGiftId = '';
    let mandatoryGift = '';
    const getCoorelationIdFromCookie = Cookies.get('one-commerce-linecheckcorrelationid') ?? '';
    const lineCheckData = getAccessDataFromLineCheck(productData?.[0]?.id);
    cartData = {
      relatedParty: [
        {
          id: 'anonymous',
          segment: 'RESIDENTIAL'
        }
      ],
      cartItem: [
        {
          itemType: 'HOME',
          promotionId: defaultPromo,
          items: [],
          note: [
            {
              author: 'linecheckCorrelationId',
              text: getCoorelationIdFromCookie
            }
          ]
        }
      ]
    };
    /**for 4P bundles*/
    const mobileItem: any = {
      itemType: 'MOBILE',
      promotionId: defaultPromo,
      items: []
    };
    /**Check if bundle or Internet and add it to cart request*/
    if (productData[0]?.isBundle) {
      productData[0]?.bundledOffers?.map((item: any) => {
        if (item?.promotionInfo?.[0]?.id) {
          const giftId =
            item?.promotionInfo?.[0]?.hardwareGift?.[0]?.ids?.length == 1
              ? item?.promotionInfo?.[0]?.hardwareGift?.[0]?.ids?.[0]
              : '';
          if (item?.productType?.toLowerCase() === 'mobile') {
            mobileItem['promotionId'] = item?.promotionInfo?.[0]?.id;
            mobGiftId = giftId;
          } else {
            cartData['cartItem'][0]['promotionId'] = item?.promotionInfo?.[0]?.id;
            mandatoryGift = giftId;
          }
        }
        if (item?.productType?.toLowerCase() == 'tv' && radioValue) {
          cartData.cartItem[0].items.push({ itemType: item?.productType, id: radioValue });
        } else if (item?.productType?.toLowerCase() === 'mobile') {
          mobileItem.items.push({ itemType: 'RATEPLAN', id: item?.id });
        } else cartData.cartItem[0].items.push({ itemType: item?.productType, id: item?.id });
      });
      mandatoryGift && cartData.cartItem[0].items?.push({ itemType: 'GIFT', id: mandatoryGift });
      mobGiftId && mobileItem.items.push({ itemType: 'GIFT', id: mobGiftId });
      if (mobileItem?.items?.length > 0) {
        cartData?.cartItem?.push(mobileItem);
      }

      //If product has tv options
      if (tvOptions?.length > 0) {
        tvOptions?.forEach((option: any) => {
          cartData.cartItem[0].items.push({ itemType: TV_SERVICE_OPTION, id: option?.id });
        });
      }
    } else {
      /**Add standlone product such as internet to cart request*/
      const mandatoryGift =
        productData?.[0]?.promotionInfo?.[0]?.hardwareGift?.[0]?.ids?.length == 1
          ? productData?.[0]?.promotionInfo?.[0]?.hardwareGift?.[0]?.ids?.[0]
          : '';
      cartData.cartItem[0].items.push({
        itemType: productData?.[0]?.productType,
        id: productData?.[0]?.id
      });
      mandatoryGift && cartData.cartItem[0].items?.push({ itemType: 'GIFT', id: mandatoryGift });
    }
    if (chooseGift && chooseGift?.length > 0) {
      chooseGift?.map((giftItem: any) => {
        giftItem?.parentPoType === 'HOME'
          ? cartData?.cartItem?.[0]?.items?.push({ itemType: 'GIFT', id: giftItem?.tuaProdId })
          : mobileItem.items?.push({ itemType: 'GIFT', id: giftItem?.tuaProdId });
      });
    }
    /**
     * changes added for new internet activation section
     */
    if (lineCheckData?.accessType) {
      cartData?.cartItem?.[0]?.note?.push({
        author: 'lineCheckaccessType',
        text: lineCheckData?.accessType
      });
    }
    if (lineCheckData?.timeSlot) {
      cartData?.cartItem?.[0]?.note?.push({
        author: 'lineCheckEarliestActivationDate',
        text: lineCheckData?.timeSlot?.start
      });
    }
    /**
     * Adding line check address while cart creation
     * As part of DEX abandon basket use case
     */
    try {
      const address: any = getCookies('chAddressJson');
      const contactMedium: any = [
        {
          characteristic: {
            installationAddress: true,
            country: 'CH',
            city: address?.selectedAdd?.city,
            street1: address?.selectedAdd?.street,
            postCode: address?.selectedAdd?.postCode,
            street2: address?.selectedAdd?.houseNumber
          }
        }
      ];
      cartData.contactMedium = contactMedium;
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.log('issue at line check address addition in create cart ==>', error);
    }
  } else if (productType === MOBILE) {
    /**Mobile*/
    if (enabledP2P) {
      cartData = {
        relatedParty: [
          {
            segment: 'RESIDENTIAL'
          }
        ],
        cartItem: [
          {
            itemType: 'MOBILE',
            promotionId: defaultPromo,
            items: [
              {
                itemType: 'RATEPLAN',
                id: productData?.[0]?.id ? productData?.[0]?.id : productData,
                subscribedInfo: {
                  installedPlan: P2PSUBSCRIBEDPLAN,
                  id: P2PData
                }
              }
            ],
            processType: {
              id: PRE_TO_POST
            }
          }
        ]
      };
    } else {
      cartData = {
        relatedParty: [
          {
            segment: 'RESIDENTIAL'
          }
        ],
        cartItem: [
          {
            itemType: 'MOBILE',
            promotionId: defaultPromo,
            items: [
              {
                itemType: 'RATEPLAN',
                id: productData?.[0]?.id ? productData?.[0]?.id : productData,
                clientDiscountInfo: discountRef
                  ? [
                      {
                        discountRef: discountRef,
                        discountType: 'DISCOUNT'
                      }
                    ]
                  : undefined
              }
            ]
          }
        ]
      };
    }
    const mandatoryGift =
      productData?.[0]?.promotionInfo?.[0]?.hardwareGift?.[0]?.ids?.length == 1
        ? productData?.[0]?.promotionInfo?.[0]?.hardwareGift?.[0]?.ids?.[0]
        : '';
    mandatoryGift && cartData.cartItem[0].items?.push({ itemType: 'GIFT', id: mandatoryGift });
    if (chooseGift && chooseGift?.length > 0) {
      chooseGift?.map((giftItem: any) => {
        giftItem?.parentPoType !== 'HOME' &&
          cartData?.cartItem?.[0]?.items?.push({ itemType: 'GIFT', id: giftItem?.tuaProdId });
      });
    }
  }

  if (isQoqaFlow) {
    const note = [];
    note.push({
      author: VOUCHERTYPE,
      text: QOQA
    });
    if (qVoucher !== '') {
      note.push({
        author: VOUCHERCODE,
        text: qVoucher
      });
      removeLocalStorage('vctype');
    }
    cartData.cartItem[0]['note'] = note;
  } else if (discountRef && discountVersion) {
    const note = [];
    note?.push({
      author: 'offerType',
      text: 'ATL'
    });
    note?.push({
      author: 'externalPromotionName',
      text: discountRef
    });
    note?.push({
      author: 'offerVersion',
      text: discountVersion
    });
    cartData.cartItem[0]['note'] = note;
  }

  //To add hardware item while creating cart
  if (deviceDetails) {
    const deviceCartItem = getDeviceCartItem(deviceDetails);
    deviceCartItem && cartData?.cartItem?.[0]?.items?.push(...deviceCartItem);
  }
  // Get flow parameter from URL query string if in browser
  let flow: string | null = null;
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    flow = params.get('flow');
  }
  
  // Add OTT items to cart if session storage exists and flow is 'ott'
  const shouldAddOttItems = ottCartData && flow === 'ott';
  if (shouldAddOttItems) {
    const ottItems = fetchOttItems(ottCartData);
    if (ottItems?.length > 0) {
      const groupedByTypeAndPromo: {
        [key: string]: { itemType: string; promotionId: string; items: any[] };
      } = {};
      const homeCartItem = cartData?.cartItem?.find((item: any) => item?.itemType === 'HOME');
      ottItems.forEach((ottItem: any) => {
        const itemType = ottItem?.itemType;
        
        // Only group OTT items, add others directly
        if (itemType === 'OTT') {
          const promoId = ottItem?.promotionId?.trim() || 'defaultOttBundle';
          const groupKey = `${'OTT'}_${promoId}`;

          if (!groupedByTypeAndPromo[groupKey]) {
            groupedByTypeAndPromo[groupKey] = {
              itemType: itemType,
              promotionId: promoId,
              items: []
            };
          }
          groupedByTypeAndPromo[groupKey].items.push(...(ottItem?.items || []));
        } else {
          // Add non-OTT items to HOME cartItem's items array
         
          if (homeCartItem && homeCartItem.items && ottItem?.items) {
            homeCartItem.items.push(...ottItem.items);
          }
        }
      });

      // Add each grouped OTT item as a separate cart item list
      Object.keys(groupedByTypeAndPromo).forEach((groupKey) => {
        const group = groupedByTypeAndPromo[groupKey];
        cartData?.cartItem.push({
          itemType: group.itemType,
          promotionId: group.promotionId,
          items: group.items
        });
      });
    }
  }

  const options = {
    headers: {
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
    }
  };

  const URL = cartUrl + APIResourceConstants.CREATE_CARTV3;
  if (Object.keys(cartData)?.length > 0) {
    const createCartV2Resp: any = await ApiServiceV2.getApiServiceInstance()
      .post(URL, cartData, options)
      .then((res: any) => {
        removeLocalStorage('isB2BCustomer');
        if (res.status == 200) {
          return res?.data;
        }
      })
      .catch((error) => {
        if (error?.response?.data?.code || error?.response?.status === 504) {
          errorTrackingDataLayer(error?.response);
        }
      });
    if (createCartV2Resp.error) {
      throw createCartV2Resp.error;
    } else {
      return createCartV2Resp;
    }
  }
};

export const fetchLinetableContent = async (slugurl: string, params: any): Promise<any> => {
  try {
    const resp = await CMSStoryblokServiceV2.get(slugurl, params)
      .then((response: any) => {
        const contentTable = response?.data?.story?.content?.body;
        // return comp;
        for (const comp of contentTable) {
          if (
            comp.component == 'productTableV2' ||
            comp.component === 'productTableWithOutLC' ||
            comp.component === 'prodConfigContainer'
          ) {
            return comp;
          } else if (comp.component == 'roamingProductTable') {
            return comp?.productTable?.[0];
          }
        }
      })
      .catch((err: any) => {
        throw err;
      });
    return resp;
  } catch (error) {
    return error;
  }
};

export const getStaticContent = (language: any = 'en', endPoints: any) => {
  try {
    return CMSStoryblokServiceV2.get(endPoints, {
      dimension: language,
      per_page: 1000,
      type: 'B2C'
    })
      .then((res: any) => {
        const response: any = {};
        (res?.data?.datasource_entries || []).map((entry: any) => {
          response[entry.name] =
            entry.dimension_value != null ? entry.dimension_value : entry.value;
        });
        try {
          localStorage.removeItem('sbstaticcontent');
          localStorage.setItem('sbstaticcontent', JSON.stringify(response));
        } catch {
          //
        }
        return response;
      })
      .catch((err) => {
        return err;
      });
  } catch {
    throw Error('Promise failed');
  }
};

export const fetchOfferingDataLineTableV2 = async (
  params: any,
  uniqueId: any,
  endpoint: any,
  existingCustomer?: boolean,
  subscriptionType?: string,
  enableReturnPromo?: boolean,
  P2PEnabled?: boolean,
  pegaIntegration?: boolean,
  deviceUltimateBundle?:boolean,
): Promise<any> => {
  localStorage.removeItem('entertainment');
  let options: any;
  options = {
    headers: {
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
    }
  };
  if (enableReturnPromo) {
    options.params = {
      returnPromo: true
    };
  }
  if (P2PEnabled) {
    options.params = {
      journey: 'P2P'
    };
  }
  if(deviceUltimateBundle){
    options.params = {
      ...options.params,
        journey: 'FPB',
      }
  }

  let URL = endpoint + APIResourceConstants.LINE_TABLEV2;
  if (pegaIntegration && localStorage.getItem('prospectId')) {
    options.headers['x-sunrise-prospect-id'] = localStorage.getItem('prospectId');
    URL = endpoint + APIResourceConstants.LINE_TABLEV3;
  }
  const subscriptionUrl = subscriptionType
    ? URL + APIResourceConstants.SUBSCRIPTION + subscriptionType
    : URL;
  //US_31295
  const finalUrl = existingCustomer || subscriptionType? subscriptionUrl : URL;
  const productDynamicData: any = await ApiServiceV2.getApiServiceInstance()
    .post(finalUrl, params, options)
    .then((res): any => {
      if (res.status == 200) {
        return res?.data;
      }
    })
    .catch((err) => {
      if (err?.response?.data?.code || err?.response?.status === 504) {
        errorTrackingDataLayer(err?.response);
      }
    });
  if (productDynamicData.error) {
    return productDynamicData.error;
  } else {
    return { [uniqueId]: productDynamicData };
  }
};

export const fetchSubscriptionData = async (category: any, endpoint: any): Promise<any> => {
  let options: any;
  options = {
    params: {},
    headers: {
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
    }
  };
  options.params = {
    category: category
  };
  const URL = endpoint;
  const subscriptionData: any = await ApiServiceV2.getApiServiceInstance()
    .get(URL, options)
    .then((res): any => {
      if (res.status == 200) {
        return res?.data;
      } else {
        return res?.status;
      }
    })
    .catch((err: any) => {
      if (err?.response?.data?.code || err?.response?.status === 504) {
        errorTrackingDataLayer(err?.response);
      }
    });
  if (subscriptionData?.error) {
    return subscriptionData?.error;
  } else {
    return { subscriptionData };
  }
};

export const getVocherPromotion = async (productID: string, voucher: string) => {
  try {
    const options = {
      headers: {
        'x-correlation-id': generateUID(),
        'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
      },
      params: {
        offerIds: productID,
        voucherCode: voucher
      }
    };

    const URL =
      LineTableBasicPropConfig?.getInstance()?.getBaseUrl() +
      `${APIResourceConstants.VOUCHER_PROMOTIONS}`;
    await ApiServiceV2.getApiServiceInstance()
      .get(URL, options)
      .then((res): any => {
        if (res.status == 200) {
          return res?.data;
        }
      });
  } catch (error) {}
};

export const validateP2P = async (msisdn: any, endpoint: any): Promise<any> => {
  let options: any;
  options = {
    params: {},
    headers: {
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
    }
  };
  options.params = {
    msisdn: msisdn
  };
  const URL = endpoint;
  return await ApiServiceV2.getApiServiceInstance()
    .get(URL, options)
    .then((res): any => {
      if (res?.data?.preToPostConversionStatus == 'OK') {
        return true;
      } else {
        return false;
      }
    })
    .catch((err) => {
      if (err?.response?.data?.code || err?.response?.status === 504) {
        errorTrackingDataLayer(err?.response);
      }
      console.log('err', err);
      return false;
    });
};

export const getDeviceDetails = async (deviceID: any, endpoint: any): Promise<any> => {
  try {
    let options: any;
    options = {
      params: {},
      headers: {
        'x-correlation-id': generateUID(),
        'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
      }
    };
    const URL = endpoint + APIResourceConstants.HARDWARES + `baseProduct__${deviceID}`;
    const deviceData: any = await ApiServiceV2.getApiServiceInstance()
      .get(URL, options)
      .then((res: any) => {
        if (res?.status === 200 && Object.keys(res?.data)?.length > 0) {
          return res?.data;
        } else {
          return null;
        }
      });
    return deviceData;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('err', err);
    return null;
  }
};

export const getDeviceModelsList = async (brandId: any, endpoint: any): Promise<any> => {
  try {
    let options: any;
    options = {
      params: {},
      headers: {
        'x-correlation-id': generateUID(),
        'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
      }
    };
    const URL = endpoint + APIResourceConstants.HARDWARE_DEVICES + `manufacturerName__${brandId}`;
    const deviceData: any = await ApiServiceV2.getApiServiceInstance()
      .get(URL, options)
      .then((res: any) => {
        if (res?.status === 200 && res?.data?.hardwares?.length > 0) {
          return res?.data;
        } else {
          return null;
        }
      });
    return deviceData;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('err', err);
    return null;
  }
};

export const trackPegaEvents = async (
  endpoint: any,
  payload = {},
  prospectId: string
): Promise<any> => {
  let options: any;
  options = {
    headers: {
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': apiResConstants.X_SUN_CHAL,
      'x-sunrise-prospect-id': prospectId
    }
  };

  let URL = endpoint + APIResourceConstants?.CUSTOMER_EVENTS;
  const productDynamicData: any = await ApiServiceV2.getApiServiceInstance()
    .post(URL, payload, options)
    .then((res): any => {
      if (res.status == 200) {
        // eslint-disable-next-line no-console
        console.log('trackPegaEvents result.data', res.data);
        return res?.data;
      }
    })
    .catch((err) => {
      if (err?.response?.data?.code || err?.response?.status === 504) {
        errorTrackingDataLayer(err?.response);
      }
    });
};

export const createCartWinV2 = async (
  productData: any,
  radioValue: string,
  defaultPromo: string,
  cartUrl: string,
  chooseGift:any
): Promise<any> => {
  let cartData: any = {};
  /**WIN FLows*/
  let mobGiftId = '';
  let mandatoryGift = '';
  const getCoorelationIdFromCookie = Cookies.get('one-commerce-linecheckcorrelationid') ?? '';
  const lineCheckData = getAccessDataFromLineCheck(productData?.[0]?.id);
  cartData = {
    relatedParty: [
      {
        id: 'anonymous',
        segment: 'RESIDENTIAL'
      }
    ],
    cartItem: [
      {
        itemType: 'HOME',
        promotionId: defaultPromo,
        items: [],
        note: [
          {
            author: 'linecheckCorrelationId',
            text: getCoorelationIdFromCookie
          }
        ]
      }
    ]
  };
  /**for 4P bundles*/
  const mobileItem: any = {
    itemType: 'MOBILE',
    promotionId: defaultPromo,
    items: []
  };
  /**Check if bundle or Internet and add it to cart request*/
  if (productData?.[0]?.isBundle) {
    productData?.[0]?.bundledOffers?.map((item: any) => {
      if (item?.promotionInfo?.[0]?.id) {
        const giftId =
          item?.promotionInfo?.[0]?.hardwareGift?.[0]?.ids?.length == 1
            ? item?.promotionInfo?.[0]?.hardwareGift?.[0]?.ids?.[0]
            : '';
        if (item?.productType?.toLowerCase() === 'mobile') {
          mobileItem['promotionId'] = item?.promotionInfo?.[0]?.id;
          mobGiftId = giftId;
        } else {
          cartData['cartItem'][0]['promotionId'] = item?.promotionInfo?.[0]?.id;
          mandatoryGift = giftId;
        }
      }
      if (item?.productType?.toLowerCase() == 'tv' && radioValue) {
        cartData.cartItem[0].items.push({ itemType: item?.productType, id: radioValue });
      } else if (item?.productType?.toLowerCase() === 'mobile') {
        mobileItem.items.push({ itemType: 'RATEPLAN', id: item?.id });
      } else cartData.cartItem[0].items.push({ itemType: item?.productType, id: item?.id });
    });
    mandatoryGift && cartData?.cartItem?.[0].items?.push({ itemType: 'GIFT', id: mandatoryGift });
    mobGiftId && mobileItem?.items?.push({ itemType: 'GIFT', id: mobGiftId });

    if (mobileItem?.items?.length > 0) {
      cartData?.cartItem?.push(mobileItem);
    }
    if (chooseGift && chooseGift?.length > 0) {
      chooseGift?.map((giftItem: any) => {
       cartData?.cartItem?.[0]?.items?.push({ itemType: 'GIFT', id: giftItem?.tuaProdId })
      })
    }
  } else {
    /**Add standlone product such as internet to cart request*/
    cartData.cartItem[0].items.push({
      itemType: productData?.[0]?.productType,
      id: productData?.[0]?.id
    });
  }
  /**
   * changes added for new internet activation section
   */
  if (lineCheckData?.accessType) {
    cartData?.cartItem?.[0]?.note?.push({
      author: 'lineCheckaccessType',
      text: lineCheckData?.accessType,
    });
  }
  if (lineCheckData?.timeSlot) {
    cartData?.cartItem?.[0]?.note?.push({
      author: 'lineCheckEarliestActivationDate',
      text: lineCheckData?.timeSlot?.start,
    });
  }
  /**
   * Adding line check address while cart creation
   * As part of DEX abandon basket use case
   */
  try {
    const address: any = getCookies('chAddressJson');
    const contactMedium: any = [
      {
        characteristic: {
          installationAddress: true,
          country: 'CH',
          city: address?.selectedAdd?.city,
          street1: address?.selectedAdd?.street,
          postCode: address?.selectedAdd?.postCode,
          street2: address?.selectedAdd?.houseNumber
        }
      }
    ];
    cartData.contactMedium = contactMedium;
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.log('issue at line check address addition in create cart ==>', error);
  }

  const options = {
    headers: {
      'x-correlation-id': generateUID(),
      'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL
    }
  };
  const endPoint = LineTableBasicPropConfig?.getInstance()?.getBaseUrl();

  const URL = `${endPoint}${API_BASE_BASEPOINT.CART_MGMT}/${APIResourceConstants.CREATE_CARTV2}`;
  if (Object.keys(cartData)?.length > 0) {
    const createCartV2Resp: any = await ApiServiceV2.getApiServiceInstance()
      .post(URL, cartData, options)
      .then((res: any) => {
        if (res.status == 200) {
          return res?.data;
        }
      });
    if (createCartV2Resp.error) {
      throw createCartV2Resp.error;
    } else {
      return createCartV2Resp;
    }
  }
}

export const fetchOttServiceOptions = async (): Promise<any> => {
  const endPoint = LineTableBasicPropConfig?.getInstance()?.getBaseUrl();
  const url = `${endPoint}${APIResourceConstants.TV_SERVICE_OPTIONS_V2}`;
  const options = {
    params: {},
    headers: {
      'x-sunrise-channel': APIResourceConstants.X_SUN_CHAL,
      'x-correlation-id': generateUID()
    }
  };
  try {
    const optionsData: any = await ApiServiceV2.getApiServiceInstance()
      .get(url, options)
      .then((res) => {
        return res?.data?.length > 0 ? res?.data : [];
      });
    return optionsData;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
};
